import { default as processClassNames } from 'classnames'
import ToggleNav from '../../components/ToggleNav'
import {
  healthPath,
  helloBabyPostPath,
  registryPath,
  registryHomePath,
  storePath,
  holidayPath,
} from 'lib/urls'
import HolidayPresentPink from 'shared/svg/holiday-present-pink.svg'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import { useFeatures } from 'flagged'
import css from '../../global-nav.scss'

interface LoggedInSiteNavSectionProps {
  activeNavItem?: string
  classNames: any
  handleToggleNav: () => void
  trackClick: (eventCta: string) => void
}

const LoggedInSiteNavSection = ({
  activeNavItem,
  classNames,
  handleToggleNav,
  trackClick,
}: LoggedInSiteNavSectionProps) => {
  const [currentUser] = useCurrentUser()
  const features = useFeatures()

  let helloBabyPost = null
  switch (currentUser?.currentRegistry?.type) {
    case 'birthday':
      helloBabyPost = 'toddler'
      break
    case 'holiday':
      helloBabyPost = 'holiday'
      break
    default:
      helloBabyPost = null
      break
  }
  return (
    <ul className={processClassNames(classNames)}>
      <ToggleNav onClick={handleToggleNav} />
      <li
        className={processClassNames(
          'hidden-xs',
          css.navLink,
          css.homeLink,
          activeNavItem === 'Home' && css.homeActive
        )}
      >
        <a href={registryHomePath} onClick={() => trackClick('Home')}>
          Home
        </a>
      </li>
      <li
        className={processClassNames(
          'hidden-xs',
          css.navLink,
          css.registryLink,
          activeNavItem === 'Registry' && css.registryActive
        )}
      >
        <a
          href={registryPath(currentUser?.currentRegistry?.urlSlug)}
          onClick={() => trackClick('Registry')}
        >
          Registry
        </a>
      </li>
      <li
        className={processClassNames(
          'hidden-xs',
          css.navLink,
          css.storeLink,
          activeNavItem === 'Store' && css.storeActive
        )}
      >
        <a href={storePath} onClick={() => trackClick('Shop')}>
          Shop
        </a>
      </li>
      {features.show_holiday_list_feature_modal && (
        <li
          className={processClassNames(
            'hidden-xs',
            css.navLink,
            css.holidayLink,
            activeNavItem === 'Holiday' && css.holidayActive
          )}
        >
          <a href={holidayPath} onClick={() => trackClick('Holiday')}>
            <span
              className={processClassNames(
                css.holidayPresent,
                css.holidayWiggle
              )}
            >
              <HolidayPresentPink height="20px" width="35px" />
            </span>
            Holiday
          </a>
        </li>
      )}
      <li
        className={processClassNames(
          'hidden-xs',
          css.navLink,
          css.guidesLink,
          activeNavItem === 'Guides' && css.guidesActive
        )}
      >
        <a
          href={helloBabyPostPath(helloBabyPost)}
          onClick={() => trackClick('Guides')}
        >
          Guides
        </a>
      </li>
      <li className={processClassNames('hidden-xs', css.navLink)}>
        <a href={healthPath} onClick={() => trackClick('Health')}>
          Health
        </a>
      </li>
    </ul>
  )
}

export default LoggedInSiteNavSection
